import { CookWidget } from '@widgets/types'
import { FunctionComponent } from 'react'
import ApiContextProvider from '@contexts/commenting/apiContextProvider'
import GenericContext from '@contexts/commenting/genericContext'
import CommentingWidget from './CommentingWidget'
import { CommentingProps } from './types'
import useUser from '@hooks/useUser'
import useAuthentication from '@hooks/useAuthentication'
import config from '@config'

const {
  publication: { publication },
} = config

const Commenting: FunctionComponent<CommentingProps> = ({
  commentsEnabled,
  id,
  postingEnabled,
}) => {
  const userData = useUser()
  const { login } = useAuthentication({ prefix: 'COM' })

  if (publication === 'romandie') {
    return null
  }

  const requireFullLogin = (action: () => void) => () => {
    userData?.email_only !== false ? login() : action()
  }

  return (
    <GenericContext.Provider
      value={{
        articleId: id,
        commentsEnabled,
        requireFullLogin,
        postingEnabled,
      }}>
      <ApiContextProvider>
        <CommentingWidget />
      </ApiContextProvider>
    </GenericContext.Provider>
  )
}

const widget: CookWidget = {
  kind: ['widget', 'commenting'],
  component: Commenting,
}

export default widget
